module.exports = __webpack_public_path__ + "static/media/instagram.d4d38cbb.svg";